module.exports = __webpack_public_path__ + "img/liveNum11.a63da4af.png";